import React, { forwardRef, memo, useImperativeHandle } from 'react';

import { useDisclosure } from '@chakra-ui/hooks';

import { useSites } from 'hooks/sites/useSites';

import { washHub } from 'store/slices';

import { createContact } from 'api/contacts';
import { useMutation, useQueryClient } from 'react-query';

import { successToast } from 'utils/successToast';

import {
  RefType,
  AddCustomerModalProps,
} from './AddCustomerContactModal.props';

import AddCustomerContactModalView from './AddCustomerContactModal.view';

const Container = forwardRef<RefType, AddCustomerModalProps>((_, ref) => {
  const queryClient = useQueryClient();
  const washHubs = washHub.selectors.useAllWashHubs();
  const washHubId = washHub.selectors.useSelectedWashHubId();

  const { data = [], isLoading } = useSites();
  const { isOpen, onOpen, onClose } = useDisclosure();

  useImperativeHandle(
    ref,
    () => ({
      onOpen,
    }),
    [onOpen],
  );

  const { mutate, isLoading: isCreating } = useMutation(createContact, {
    onSuccess: () => {
      successToast('Customer Contact Created Successfully');

      queryClient.invalidateQueries(`fetch-contacts-${washHubId}`);

      queryClient.invalidateQueries(`fetch-contacts-${washHubId}-select`, {
        exact: true,
      });

      onClose();
    },
  });

  const _props = {
    isOpen,
    onClose,
    washHubs,
    isCreating,
    sites: data,
    onCreate: async (payload: any) => {
      mutate({
        ...payload,
        phone: payload.phone.toString(),
      });
    },
    isLoadingSites: isLoading,
  };

  return <AddCustomerContactModalView {..._props} />;
});

const AddCustomerContactModal = memo(Container);

export default AddCustomerContactModal;
